export function waitForLoadedSettings(getValue: Function, { timeoutMs = 30000, intervalMs = 50 } = {}) {
    return new Promise((resolve, reject) => {
        const startedAt = Date.now();
        const timer = setInterval(() => {
            try {
                const value = getValue();
                if (value !== undefined && value !== null) {
                    clearInterval(timer);
                    resolve(value);
                    return;
                }
                if (Date.now() - startedAt >= timeoutMs) {
                    clearInterval(timer);
                    reject(new Error('Timed out waiting for value'));
                }
            } catch (error) {
                clearInterval(timer);
                reject(error);
            }
        }, intervalMs);
    });
}
